import { render } from "./ToDoList.vue?vue&type=template&id=1bf16908"
import script from "./ToDoList.vue?vue&type=script&lang=js"
export * from "./ToDoList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/ToDo/ToDoList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1bf16908"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1bf16908', __exports__)) {
    console.log('reload')
    api.reload('1bf16908', __exports__)
  }
  
  module.hot.accept("./ToDoList.vue?vue&type=template&id=1bf16908", () => {
    console.log('re-render')
    api.rerender('1bf16908', render)
  })

}


export default __exports__